import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]

  connect() {
    this.boundClickAway = this.handleClickAway.bind(this)
    document.addEventListener("click", this.boundClickAway)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickAway)
  }

  toggle(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle("hidden")
  }

  handleClickAway(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
    }
  }
}
